"use client";

import { Box, BoxProps } from "@mui/system";
import Image from "next/image";
import logo from "public/images/OPT-Green-Butterfly-only.svg";
import style from "./OpteraSpinner.module.css";

interface SpinnerProps extends BoxProps {
	size?: number;
	butterfly?: boolean;
}

/**
 * A loading spinner that is distinct from the MUI circular progress.
 * - `butterfly`: renders the Optera butterfly animation instead of default dots.
 * - `size`: in px. Only impacts butterfly logo.
 */
export default function OpteraSpinner({
	size = 80,
	butterfly = false,
	...boxProps
}: SpinnerProps) {
	return (
		<Box {...boxProps} className={style.loadingContainer}>
			{butterfly ? (
				<div className={style.butterflySpinner}>
					<Image
						src={logo}
						alt="Optera Logo"
						width={size}
						height={size}
						priority
					/>
				</div>
			) : (
				<div className={style.dotsSpinner}>
					<div></div>
					<div></div>
					<div></div>
				</div>
			)}
		</Box>
	);
}
